function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.top <= window.innerHeight - rect.height / 2;
}

function richText() {
  document.querySelectorAll(".kik_linked_to").forEach(function (item) {
    if (isElementInViewport(item)) {
      if (item.getAttribute("id") != "") {
        document.querySelectorAll(".sticky_tab_item").forEach(function (elem) {
          elem.classList.remove("active");
        });
        document
          .querySelector(
            ".sticky_tab_item a[href='#" + item.getAttribute("id") + "']"
          )
          .closest(".sticky_tab_item")
          .classList.add("active");
      }
    }
  });
}

let check_prev = "";

function check_elem_g() {
  document.querySelectorAll(".sticky_tab_item").forEach(function (ce) {
    setTimeout(function () {
      if (ce.classList.contains("active")) {
        if (ce != check_prev) {
          console.log(
            ce.getBoundingClientRect().left,
            ce.getBoundingClientRect().right
          );
          if (ce.getBoundingClientRect().right > window.innerWidth) {
            document.querySelector(".sticky_tabs").scrollBy({
              left: ce.getBoundingClientRect().left,
              top: 0,
              behavior: "smooth",
            });
          }
          if (ce.getBoundingClientRect().left < 0) {
            document.querySelector(".sticky_tabs").scrollBy({
              left: ce.getBoundingClientRect().left,
              top: 0,
              behavior: "smooth",
            });
          }
        }
        check_prev = ce;
      }
    }, 10);
  });
}
window.addEventListener("scroll", richText);
window.addEventListener("scroll", check_elem_g);

document.querySelectorAll(".kik_explore_title").forEach(function (item) {
  item.addEventListener("click", function () {
    document.querySelectorAll(".kik_explore_title").forEach(function (elem) {
      elem.classList.remove("active");
    });
    document.querySelectorAll(".kik_explore_content").forEach(function (elem) {
      elem.classList.remove("active");
    });
    item.classList.add("active");
    document
      .querySelector(
        ".kik_explore_content[data_open='" +
          item.getAttribute("data_open") +
          "']"
      )
      .classList.add("active");
  });
});

document.querySelectorAll(".essentials_link_item").forEach(function (item) {
  item.addEventListener("click", function () {
    item
      .closest(".kik_essentials_c")
      .querySelectorAll(".essentials_link_item")
      .forEach(function (elem) {
        elem.classList.remove("active");
      });
    item
      .closest(".kik_essentials_c")
      .querySelectorAll(".essentials_collection_x")
      .forEach(function (elem) {
        elem.classList.remove("active");
      });
    item.classList.add("active");
    document
      .querySelector(
        ".essentials_collection_x[data_collection='" +
          item.getAttribute("data_collection") +
          "']"
      )
      .classList.add("active");
  });
});

document.querySelectorAll(".compare_openpopup ").forEach(function (item) {
  item.addEventListener("click", function () {
    item
      .closest(".shopify-section")
      .querySelector(".essentials_popup_c")
      .classList.add("active");
  });
});
document.querySelectorAll(".essentials_popup_close").forEach(function (item) {
  item.addEventListener("click", function () {
    item.closest(".essentials_popup_c").classList.remove("active");
  });
});
document.querySelectorAll(".essentials_popup_overlay").forEach(function (item) {
  item.addEventListener("click", function () {
    item.closest(".essentials_popup_c").classList.remove("active");
  });
});
document.querySelectorAll(".promo_icon").forEach(function (elem) {
  elem.addEventListener("click", function (e) {
    e.preventDefault();
    
    // 1. 获取要复制的文本 (支持 input 或直接从 data 属性获取)
   let copyInput = elem.querySelector("#myInput") || elem.querySelector(".my-copy-input");
    if (!copyInput) return;
    
    const textToCopy = copyInput.value;

    // 2. 核心：尝试使用传统 execCommand 方法 (绕过 Permission Policy)
    // 创建一个隐藏的 textarea 确保在任何环境下都能选中
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    
    // 确保 textarea 在视图内但不可见，避免页面跳动
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    document.body.appendChild(textArea);
    
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, 99999);

    try {
      // 执行复制
      const successful = document.execCommand('copy');
      if (successful) {
        console.log('复制成功 (execCommand)');
        elem.classList.add("active");
        setTimeout(function () {
          elem.classList.remove("active");
        }, 2000);
      }
    } catch (err) {
      console.error('execCommand 复制失败:', err);
    }

    // 移除临时对象
    document.body.removeChild(textArea);
  });
});
